export default [
  {
    component: () => import("pages/excluded_mentions/ExcludedMentionsPage.vue"),
    meta: {
      accessLevel: "organisation_read",
      title: "Excluded Mentions",
    },
    name: "excluded-mentions",
    path: "/excluded-mentions",
    props: (route) => ({
      reviewed: route.query.reviewed,
      targetId: route.query.target_id,
    }),
  },
];
